export default "/images/cat-logo-4.png?9a4ddbda870662bad69ea9f8f1d53706";